module.exports = __webpack_public_path__ + "img/ennetix-login.d5466794.png";